import { ConnectedAdDeliveryReportPage } from "fleet/controller/report/connected-ad-delivery";
import { ConnectedReportIncidentDetail } from "fleet/controller/report/connected-incident-detail";
import { ConnectedUptime } from "fleet/controller/report/connected-uptime";
import { ConnectedUptimeReportDevicePage } from "fleet/controller/report/connected-uptime-device";
import { ConnectedDevicesUptime } from "fleet/controller/report/connected-uptime-devices";
import React from "react";
import { Route } from "react-router-dom";
import { PrivateRoute } from "ui/private-route";

function renderReportsRoutes() {
  return [
    <PrivateRoute
      exact
      path="/reports"
      key="reports"
      component={ConnectedUptime}
    />,
    <PrivateRoute
      exact
      path="/reports/uptime/:networkId/:start/:end/devices/:date"
      key="reports-uptime-network-date"
      component={ConnectedDevicesUptime}
    />,
    <PrivateRoute
      exact
      path="/reports/uptime/:networkId/:start/:end/device/:deviceId"
      key="reports-uptime-network-device"
      component={ConnectedUptimeReportDevicePage}
    />,
    <PrivateRoute
      exact
      path="/reports/uptime/:networkId/:start/:end"
      key="reports-uptime-network"
      component={ConnectedUptime}
    />,
    <PrivateRoute
      exact
      path="/reports/ad-delivery"
      key="report-ad-delivery"
      component={ConnectedAdDeliveryReportPage}
    />,
    <Route
      exact
      path="/reports/incident-detail/:jwtToken"
      key="report-incident-details"
      component={ConnectedReportIncidentDetail}
    />,
  ];
}

export { renderReportsRoutes };
